if (!customElements.get("gift-card-recipient-form")) {
  customElements.define(
    "gift-card-recipient-form",
    class GiftCardRecipientForm extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.currentProductVariantId = this.dataset.productVariantId;

        this.selectors = {
          checkBox: `[data-recipient-checkbox="${this.sectionId}"]`,
          controlInput: `[data-recipient-control="${this.sectionId}"]`,
          emailInput: `[data-recipient-email="${this.sectionId}"]`,
          nameInput: `[data-recipient-name="${this.sectionId}"]`,
          senderNameInput: `[data-recipient-sender-name="${this.sectionId}"]`,
          messageInput: `[data-recipient-message="${this.sectionId}"]`,
          sendOnInput: `[data-recipient-send-on="${this.sectionId}"]`,
          offSetInput: `[data-recipient-off-set="${this.sectionId}"]`,
        };

        this.checkboxInput = this.querySelector(this.selectors.checkBox);

        this.hiddenControlField = this.querySelector(this.selectors.controlInput);

        this.activeInputs = {
          email: this.querySelector(this.selectors.emailInput),
          name: this.querySelector(this.selectors.nameInput),
          message: this.querySelector(this.selectors.messageInput),
          send_on: this.querySelector(this.selectors.sendOnInput),
        };

        this.senderNameInput = this.querySelector(this.selectors.senderNameInput);

        this.offsetProperty = this.querySelector(this.selectors.offSetInput);

        this.handleChange = this.onChange.bind(this);
        this.handleCartErrors = this.onCartErrors.bind(this);
        this.handleVariantChanged = this.onVariantChanged.bind(this);
        this.handleMiniCartOpen = this.resetRecipientForm.bind(this);

        if (this.checkboxInput) {
          this.checkboxInput.disabled = false;
        }

        if (this.hiddenControlField) {
          this.hiddenControlField.disabled = true;
        }

        if (this.offsetProperty) {
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        }

        this.onChange();

        this.addEventListener("change", this.handleChange);
      }

      connectedCallback() {
        document.addEventListener("cart:errors", this.handleCartErrors);

        document.addEventListener("variant:changed", this.handleVariantChanged);

        document.addEventListener("mini-cart:open", this.handleMiniCartOpen);
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.handleChange);

        document.removeEventListener("cart:errors", this.handleCartErrors);

        document.removeEventListener("variant:changed", this.handleVariantChanged);

        document.removeEventListener("mini-cart:open", this.handleMiniCartOpen);
      }

      onCartErrors({ detail }) {
        if (
          detail.source !== "product-form" ||
          String(detail.productVariantId) !== String(this.currentProductVariantId)
        ) {
          return;
        }

        this.displayErrorMessage(detail.errors);
      }

      onVariantChanged({ detail }) {
        const productForm = this.closest("product-form");
        const variantSelectors = productForm?.querySelector("product-form-selectors");

        if (variantSelectors === detail.source && detail.variant) {
          this.currentProductVariantId = detail.variant.id.toString();
        }
      }

      onChange() {
        if (this.checkboxInput?.checked) {
          this.enableInputFields();
          return;
        }

        this.clearInputFields();
        this.disableInputFields();
        this.clearErrorMessages();
      }

      inputFields() {
        return [...Object.values(this.activeInputs), this.senderNameInput].filter(Boolean);
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty].filter(Boolean);
      }

      clearInputFields() {
        this.inputFields().forEach((field) => {
          field.value = "";
        });
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => {
          field.disabled = false;
        });
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => {
          field.disabled = true;
        });
      }

      displayErrorMessage(errors) {
        if (!errors || typeof errors !== "object") {
          return;
        }

        Object.entries(errors).forEach(([key, value]) => {
          const input = this.activeInputs[key];

          if (!input) return;

          const errorElement = input.closest(".input-label")?.querySelector(".input-label__error");

          if (!errorElement) return;

          const messages = Array.isArray(value) ? value : [value];

          errorElement.textContent = `${messages.join(", ")}.`;

          input.setAttribute("aria-invalid", "true");

          input.classList.add("error");
        });
      }

      clearErrorMessages() {
        this.inputFields().forEach((field) => {
          field.setAttribute("aria-invalid", "false");

          field.classList.remove("error");

          const errorElement = field.closest(".input-label")?.querySelector(".input-label__error");

          if (errorElement) {
            errorElement.textContent = "";
          }
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput) {
          this.checkboxInput.checked = false;
        }

        this.clearInputFields();
        this.disableInputFields();
        this.clearErrorMessages();
      }
    },
  );
}
